export const BASE_URL = "https://xukkhyvc.directus.app/items";
export const ASSETS_URL = "https://xukkhyvc.directus.app/assets/";

export const QRCODE_URL = "https://negoloc37-automoto.fr/synchronisation";
